<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 280px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[1]" v-text="node.label.split('###')[0]"></span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card ref="right_content" class="box-card" style="width: calc(100% - 290px);">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>报告类型：</label>
                        <el-select v-model="search_Obj.f_result_type" placeholder="请选择" @change="doSearch">
                            <el-option label="监测对比报告" value="2"></el-option>
                            <el-option label="抽检对比报告" value="4"></el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>处置结果：</label>
                        <el-select v-model="search_Obj.f_result" clearable placeholder="请选择" @change="doSearch">
                            <el-option v-for="item in enuObj('verify_result1')" :key="'verify_result1'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>处置方式：</label>
                        <el-select v-model="search_Obj.f_deal_type" clearable placeholder="请选择" @change="doSearch">
                            <el-option v-for="item in enuObj('report_deal_type')" :key="'report_deal_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>有无备注：</label>
                        <el-select v-model="search_Obj.f_has_remark" clearable placeholder="请选择" @change="doSearch">
                            <el-option v-for="item in enuObj('yesNo')" :key="'has_remark'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>孔号：</label>
                        <el-input v-model="search_Obj.f_hole_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>段号：</label>
                        <el-input v-model="search_Obj.f_segment_no" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>开始时间：</label>
                        <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="dateRangeSet"
                            style="width:320px">
                        </el-date-picker>
                    </div>
                    <div class="searchGroup">
                        <label>注浆量区间：</label>
                        <el-input v-model="search_Obj.grout_volume_min" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                        <span style="margin: 0 2px">-</span>
                        <el-input v-model="search_Obj.grout_volume_max" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>注浆量差值：</label>
                        <el-input v-model="search_Obj.grout_volume_cha" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>注灰量区间：</label>
                        <el-input v-model="search_Obj.ash_volume_min" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                        <span style="margin: 0 2px">-</span>
                        <el-input v-model="search_Obj.ash_volume_max" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>注灰量差值：</label>
                        <el-input v-model="search_Obj.ash_volume_cha" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>透水率区间：</label>
                        <el-input v-model="search_Obj.permeable_rate_min" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                        <span style="margin: 0 2px">-</span>
                        <el-input v-model="search_Obj.permeable_rate_max" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>透水率差值：</label>
                        <el-input v-model="search_Obj.permeable_rate_cha" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>最大密度差：</label>
                        <el-input v-model="search_Obj.density_cha_max" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>最大压力差：</label>
                        <el-input v-model="search_Obj.pressure_cha_max" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="unit_code" label="单元编号" sortable="custom" min-width="180"></el-table-column>
                        <el-table-column prop="hole_code" label="孔号" sortable="custom" min-width="180"></el-table-column>
                        <el-table-column prop="segment_no" label="段号" sortable="custom" width="80"></el-table-column>
                        <el-table-column prop="work_type_int" label="作业方式" sortable="custom" width="110">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.work_type_int, "work_type_int") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="begin_time" label="开始时间" sortable="custom" width="160"></el-table-column>
                        <el-table-column prop="grout_volume" label="注浆量" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="grout_volume1" label="对比注浆量" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="grout_volume_cha" label="注浆量差值" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="ash_volume" label="注灰量" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="ash_volume1" label="对比注灰量" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="ash_volume_cha" label="注灰量差值" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="permeable_rate" label="透水率" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="permeable_rate1" label="对比透水率" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="permeable_rate_cha" label="透水率差值" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="density_cha_max" label="最大密度差" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="pressure_cha_max" label="最大压力差" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="has_remark" label="有备注" sortable="custom" width="100">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.has_remark, "yesNo") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="处置结果" width="120">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.result, "verify_result1") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
            </div>
        </el-card>
        <Info
            :report_type="report_type"
            :report_id="report_id"
            title="处置对比报告"
            :isshow="infoshow"
            @on-close="closeInfoDialog"
            @on-save-ok="saveDealOk">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import listutil from "@/libs/listutil"
import Info from "./checkinfo.vue"
import { getListData } from '@/api/common'
import { getProjectDivisionTreeData } from '@/api/org'
import { reCreateVerifyReportBatch, autoDealBatch } from '@/api/statistic'

export default {
    name: 'reportDealResult',
    mixins: [listutil],
    components: {Btns, LabBtns, Info},
    data() {
        return {
            m_name: '待处置报告',
            menu_id: 5960,
            list_url: "/api/admin/reportdealresult/list",
            search_Obj: {
                pid: '',
                f_result_type: '2',
                f_result: '0',
                f_unit_code: '',
                f_hole_code: '',
                f_segment_no: '',
                f_has_remark: '',
                f_deal_type: '',
                grout_volume_max: '',
                grout_volume_min: '',
                ash_volume_max: '',
                ash_volume_min: '',
                permeable_rate_max: '',
                permeable_rate_min: '',
                grout_volume_cha: '',
                ash_volume_cha: '',
                permeable_rate_cha: '',
                density_cha_max: '',
                pressure_cha_max: '',
            },
            del_Obj:{
                url:'/api/admin/workreport1/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['work_type_int', 'verify_result1', 'yesNo', 'report_deal_type'],
            report_id: 0,
            report_type: 0,
            grade: 1,
            pid: 0,
            projectDivisionData: [],
            openKeys: [],
            dateRange: '',
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(2).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.search_Obj.pid = data.id
            this.getListData()
        },
        doSearch() {
            if ((this.$isNotNull(this.search_Obj.permeable_rate_max) || this.$isNotNull(this.search_Obj.permeable_rate_min) || this.$isNotNull(this.search_Obj.permeable_rate_cha)) && (this.$isNotNull(this.search_Obj.grout_volume_max) || this.$isNotNull(this.search_Obj.grout_volume_min) || this.$isNotNull(this.search_Obj.grout_volume_cha) || this.$isNotNull(this.search_Obj.ash_volume_max) || this.$isNotNull(this.search_Obj.ash_volume_min)|| this.$isNotNull(this.search_Obj.ash_volume_cha))) {
                this.$msg("注浆量、注灰量不能与透水率同时检索")
                return
            }
            this.current = 1
            this.search_Obj["pageNum"] = this.current;
            this.getListData()
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.grade = res.data.grade
                    this.pid = res.data.pid
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(this.pid);
                    }, 1000);
                }
            })
        },
        dealReport(index, row){
            this.report_id = row.report_id
            this.report_type = row.result_type
            this.infoshow = true
        },
        saveDealOk(){
            this.getListData()
            this.infoshow = false
        },
        reCreateBatch(){
            if (this.selectData.length <= 0) {
                this.$msg("请选择要重新生成的数据")
            } else {
                this.$confirm('确定要批量重新生成吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = '';
                    for (let data of this.selectData) {
                        if (ids === '') {
                            ids = data.id + "";
                        } else {
                            ids += "," + data.id;
                        }
                    }
                    reCreateVerifyReportBatch(ids, this.search_Obj.f_result_type).then(res=>{
                        if(res.code == 1){
                            this.$msgs(res.msg)
                        }else{
                            this.$msg(res.msg)
                        }
                    })
                }).catch(() => { })
            }
        },
        autoDeal(){
            autoDealBatch(this.search_Obj.f_result_type).then(res=>{
                if(res.code == 1){
                    this.$msgs(res.msg)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_begin_time_s_date = val[0]
                this.search_Obj.f_begin_time_e_date = val[1]
            }else{
                this.search_Obj.f_begin_time_s_date = ''
                this.search_Obj.f_begin_time_e_date = ''
            }
        },
    }
};
</script>
<style lang="less" scoped>
    .titleBoxwhr {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
    .carBox .el-card:first-child /deep/ .el-card__body {
        padding: 20px 6px;
    }
    .el-table /deep/ .el-table__cell {
        padding: 10px 0;
    }
</style>